import { AxiosError } from 'axios';

export const isAxiosError = (error: Error): error is AxiosError => 'response' in error
&& 'request' in error
&& 'isAxiosError' in error
&& (error as AxiosError).isAxiosError;
